// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__10Lgs","bigColWidth":"Table_bigColWidth__2ffWq","biggerColWidth":"Table_biggerColWidth__3W_QR","row":"Table_row__2JnU-","col":"Table_col__17qEh"};